export default function RefundPolicyPage() {
  return (
    <div className="max-w-[900px] mx-auto px-6 md:px-12 py-16" data-testid="refund-policy-page">
      <h1 className="font-serif text-4xl font-medium text-nexa-charcoal mb-8">Refund and Return Policy</h1>
      <p className="text-muted-foreground mb-8">Last Updated: January 1, 2026</p>
      <div className="prose prose-lg max-w-none text-nexa-charcoal space-y-8">
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">Our Commitment</h2>
          <p className="text-muted-foreground leading-relaxed">At Nexaorbits, we want you to be completely satisfied with your purchase. If for any reason you are not happy with your order, we offer a hassle-free 30-day return policy.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">30-Day Return Policy</h2>
          <p className="text-muted-foreground leading-relaxed">You have 30 days from the date of delivery to return items for a full refund or exchange. Items must be returned in their original condition, unused, and with all original packaging and tags attached.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">Eligible Items for Return</h2>
          <ul className="list-disc list-inside text-muted-foreground space-y-2">
            <li>Items in original, unused condition</li>
            <li>Items with all original tags and packaging</li>
            <li>Items returned within 30 days of delivery</li>
            <li>Items that are not marked as final sale</li>
          </ul>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">Non-Returnable Items</h2>
          <ul className="list-disc list-inside text-muted-foreground space-y-2">
            <li>Items marked as Final Sale</li>
            <li>Personalized or custom-made items</li>
            <li>Items that have been used or damaged by the customer</li>
            <li>Items without original packaging or tags</li>
          </ul>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">How to Initiate a Return</h2>
          <ol className="list-decimal list-inside text-muted-foreground space-y-2">
            <li>Contact our customer service at support@nexaorbits.store with your order number</li>
            <li>Receive return authorization and shipping instructions</li>
            <li>Pack your items securely in their original packaging</li>
            <li>Ship the items to our returns center</li>
            <li>Receive your refund once we process the return</li>
          </ol>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">Return Shipping</h2>
          <p className="text-muted-foreground leading-relaxed"><strong>Defective or Incorrect Items:</strong> We will provide a prepaid shipping label for returns due to defects or errors on our part.<br /><br /><strong>Change of Mind:</strong> Customers are responsible for return shipping costs for items returned due to change of mind or preference.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">Refund Process</h2>
          <p className="text-muted-foreground leading-relaxed">Once we receive and inspect your return, we will process your refund within 5-7 business days. Refunds will be credited to your original payment method.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">Contact Us</h2>
          <p className="text-muted-foreground leading-relaxed"><strong>Email:</strong> support@nexaorbits.store<br /><strong>Phone:</strong> +1-888-351-1122<br /><strong>Hours:</strong> Monday - Friday, 9:00 AM - 6:00 PM EST</p>
        </section>
      </div>
    </div>
  );
}
